import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppLoaderService } from '../service/app-loader/app-loader.service';
import { StyleDirectionService } from '../service/style-direction/style-direction.service';
import { LocalStoreService } from '../service/local-store.service';
;

@Component({
  selector: 'app-header-two',
  templateUrl: './header-two.component.html',
  styleUrls: ['./header-two.component.scss']
})
export class HeaderTwoComponent {

    CurrentLangSrc: string = "assets/img/flag/us-flag.jpg";
    CurrentLangName: string = "Eng";
    CurrentLangCode: string = "en";

    SecondLangSrc: string = "assets/img/flag/arab-flag.jpg";
    SecondLangName: string = "عربي";
    SecondLangCode: string = "ar";
    currentLang: string = "en";


    CurrentCurrencyName: string = "OMR";
    CurrentCurrencyCode: string = "1";

    SecondCurrencyName: string = "$";
    SecondCurrencyCode: string = "2";
    currentCurrency: string = "1";


    //mainForm: CurrencyModule = new CurrencyModule();

    constructor(private localS: LocalStoreService, public translate: TranslateService, private styleDir: StyleDirectionService,  private loader: AppLoaderService) { }

    ngOnInit(): void {
        if (this.localS.getItem('Lang') == 'ar') {
            this.currentLang = "ar";
        }

        if (this.currentLang !== 'ar') {

            this.CurrentLangSrc = "assets/img/flag/us-flag.jpg";
            this.CurrentLangName = "Eng";
            this.CurrentLangCode = "en";

            this.SecondLangSrc = "assets/img/flag/arab-flag.jpg";
            this.SecondLangName = "عربي";
            this.SecondLangCode = "ar";
        }
        else if (this.currentLang === 'ar') {
            this.SecondLangSrc = "assets/img/flag/us-flag.jpg";
            this.SecondLangName = "Eng";
            this.SecondLangCode = "en";

            this.CurrentLangSrc = "assets/img/flag/arab-flag.jpg";
            this.CurrentLangName = "عربي";
            this.CurrentLangCode = "ar";
        }
        //var curID = this.localS.getItem('CurrencyID');
        //if (curID == null) {

        //    this.currentCurrency = "2";
        //    this.setCurrency(false);
        //    this.toggleClassCurr();
        //}
        //else {
        //    this.currentCurrency = curID;
        //    if (this.currentCurrency == '1') {

        //        this.CurrentCurrencyName = "OMR";
        //        this.CurrentCurrencyCode = "1";

        //        this.SecondCurrencyName = "$";
        //        this.SecondCurrencyCode = "2";

        //    }
        //    else {

        //        this.CurrentCurrencyName = "$";
        //        this.CurrentCurrencyCode = "2";

        //        this.SecondCurrencyName = "OMR";
        //        this.SecondCurrencyCode = "1";
        //    }
        //}
    }



    classApplied = false;
    //classAppliedCurr = false;

    toggleClassLang() {
        this.classApplied = !this.classApplied;
    }

    //toggleClassCurr() {
    //    this.classAppliedCurr = !this.classAppliedCurr;
    //}

    //private datas: any;
    //setCurrency(isRefresh: boolean) {



    //    if (this.currentCurrency !== '1') {

    //        this.CurrentCurrencyName = "OMR";
    //        this.CurrentCurrencyCode = "1";

    //        this.SecondCurrencyName = "$";
    //        this.SecondCurrencyCode = "2";

    //    }
    //    else {

    //        this.CurrentCurrencyName = "$";
    //        this.CurrentCurrencyCode = "2";

    //        this.SecondCurrencyName = "OMR";
    //        this.SecondCurrencyCode = "1";
    //    }

    //    if (this.currentCurrency === "2") {
    //        this.currentCurrency = "1";

    //        //Save
    //        this.localS.setItem('CurrencyID', this.currentCurrency);
    //        this.localS.setItem('CurrencyRate', "1");
    //        this.localS.setItem('CurrencyName', this.CurrentCurrencyName);
    //        this.toggleClassCurr();
    //        if (isRefresh) {
    //            window.location.reload();
    //        }
    //    }
    //    else {
    //        this.currentCurrency = "2";

    //        this.loader.open();
    //        this.service.getServiceId(2)
    //            .subscribe(res => {
    //                this.datas = res as CurrencyModule[];

    //                this.mainForm.gnCurrencyID = this.datas.gnCurrencyID;
    //                this.mainForm.currFormat = this.datas.currFormat;
    //                this.mainForm.isVisible = this.datas.isVisible;
    //                this.mainForm.nameAr = this.datas.nameAr;
    //                this.mainForm.name = this.datas.name;
    //                this.mainForm.notes = this.datas.notes;
    //                this.mainForm.rate = this.datas.rate;


    //                this.localS.setItem('CurrencyID', this.currentCurrency);
    //                this.localS.setItem('CurrencyRate', this.mainForm.rate);
    //                this.localS.setItem('CurrencyName', this.CurrentCurrencyName);
    //                this.toggleClassCurr();
    //                if (isRefresh) {
    //                    window.location.reload();
    //                }
    //                this.loader.close();
    //            },
    //                err => {
    //                    this.loader.close(); console.log(err);


    //                    this.localS.setItem('CurrencyID', this.currentCurrency);
    //                    this.localS.setItem('CurrencyRate', "0.385");
    //                    this.localS.setItem('CurrencyName', this.CurrentCurrencyName);
    //                    this.toggleClassCurr();
    //                    if (isRefresh) {
    //                        window.location.reload();
    //                    }
    //                });


    //    }


    //}


    setLang() {
        if (this.currentLang === "ar") {
            this.currentLang = "en";
        }
        else {
            this.currentLang = "ar";

        }

        

        this.localS.setItem('Lang', this.currentLang);
        this.toggleClassLang();
        
        window.location.reload();
    }


}
